import styled from 'styled-components';

export const ImageDescriptionContainer = styled.div`
  display: flex;
  width: 240px;
  padding: 12px 24px;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 24px;
  border: 1px solid #fff;
  background: linear-gradient(
    104deg,
    rgba(255, 255, 255, 0.5) 15.43%,
    rgba(255, 255, 255, 0.2) 85.25%
  );
  z-index: 6;
  position: absolute;

  @media only screen and (max-width: 700px) {
    width: 180px;
    padding: 8px 16px;
  }
`;

export const ImageDescriptionName = styled.p`
  color: ${(props) => props.color || '#100722'};
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  @media only screen and (max-width: 700px) {
    font-size: 14px;
  }
`;

export const ImageDescriptionPosition = styled.p`
  color: ${(props) => props.color || '#100722'};
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media only screen and (max-width: 700px) {
    font-size: 12px;
  }
`;
